import React from "react";
import "../../../assets/css/Stepper.css"; // custom styles (added below)
import { useNavigate } from "react-router-dom";

const Stepper = ({ step, editId }) => {

    const navigate = useNavigate()
    return (
        <div className="stepper-wrapper">

            <div className="d-flex">
                {!editId && (<button
                    onClick={() => navigate(-1)}
                    style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0 }}
                    title="Go back"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        fill="none"
                        stroke="#7F56DA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="19" y1="12" x2="5" y2="12"></line>
                        <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                </button>)}
                <h2 className='main-heading' style={{ margin: 0, color: "#7F56DA" }}>{editId ? "Edit" : "Create"} Activity</h2>
            </div>

            <div className="text-muted mb-3 mt-3">
                Step 1: Student Selection — Step 2: Activity Configuration
            </div>

            <div className="row stepper-row">

                {/* ---------- STEP 1 ---------- */}
                <div className="col-md-6">
                    <div
                        className={`step-box ${step === 1 ? "active-step" : ""}`}
                    >
                        <div className="step-number">{1}</div>
                        <div>
                            <div className="step-title">Select Students</div>
                            <div className="step-subtitle">
                                Choose course/semester/section and select students
                            </div>
                        </div>
                    </div>
                </div>

                {/* ---------- STEP 2 ---------- */}
                <div className="col-md-6">
                    <div
                        className={`step-box ${step === 2 ? "active-step" : ""}`}
                    >
                        <div className="step-number">{2}</div>
                        <div>
                            <div className="step-title">Activity Configuration</div>
                            <div className="step-subtitle">
                                Name, timeline, checks, payments, assignment & notifications
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Stepper;
